module.exports = __webpack_public_path__ + "img/bg_teachers_day@2x.33d7079e.png";